import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	confirmDiscardChangesNoticeBody: {
		id: 'proforma-panel-in-issue-view-ui.controllers.use-handle-form-selected.confirm-discard-changes-notice-body',
		defaultMessage:
			'There are changes to answers on the “{formName}” form that will be lost if you choose "Confirm". Are you sure you want to continue?',
		description:
			'The content of the confirmation modal informing that existing changes will be lost, before moving to another form.',
	},
	confirmDiscardChangesNoticeTitle: {
		id: 'proforma-panel-in-issue-view-ui.controllers.use-handle-form-selected.confirm-discard-changes-notice-title',
		defaultMessage: 'Confirm Discarding Changes',
		description:
			'The title of the confirmation modal informing that existing changes will be lost, before moving to another form.',
	},
	noticeCloseLabel: {
		id: 'proforma-panel-in-issue-view-ui.controllers.use-handle-form-selected.notice-close-label',
		defaultMessage: 'Close',
		description: 'The label for the close button on the notices.',
	},
	noticeConfirmLabel: {
		id: 'proforma-panel-in-issue-view-ui.controllers.use-handle-form-selected.notice-confirm-label',
		defaultMessage: 'Confirm',
		description: 'The label for the confirm button on the notices.',
	},
});
